define(["jquery", "knockout", "@modules/content/salesEvent/salesEventDialogViewModel"], function ($, ko, SalesEventDialogViewModel) {
    function displayModal() {
        $("#onlineSeminarOverlay").modal();
    }

    if (window.scan && window.scan.salesEventDialog && $("#onlineSeminarOverlay").length > 0) {
        var salesEventDialogValues = window.scan.salesEventDialog;
        var element = document.getElementById("onlineSeminarOverlay");
        var model = new SalesEventDialogViewModel(salesEventDialogValues.seminarLink);
        ko.applyBindings(model, element);

        if (salesEventDialogValues.triggerSelector) {
            $(document).on("click", salesEventDialogValues.triggerSelector, function (e) {
                e.preventDefault();
                displayModal();
            });
        }
    }
});
